/* Three-state theme switch, transcribed from Claude Design "Astrography Home v2":
   auto → light → dark → auto. `auto` follows the operating system and keeps
   following it while the tab is open.

   The <html> attributes are already correct when this file runs — the inline
   script in layout/theme.liquid writes them before the first paint, which is
   what stops a light page flashing in front of a dark-mode visitor. Everything
   here is the interactive half: the click, the system change, and the button's
   own label.

   Clicks are delegated from the document, so the switch survives the theme
   editor re-rendering the header section. */
(() => {
  const KEY = 'ag-theme';
  const NEXT = { auto: 'light', light: 'dark', dark: 'auto' };
  const root = document.documentElement;
  const mq = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;

  const currentMode = () => {
    const m = root.getAttribute('data-mode');
    return m === 'light' || m === 'dark' ? m : 'auto';
  };

  const label = (btn, mode) => btn.dataset['title' + mode[0].toUpperCase() + mode.slice(1)] || '';

  const syncButtons = (mode) => {
    document.querySelectorAll('[data-ag-theme-btn]').forEach((btn) => {
      const text = label(btn, mode);
      if (!text) return;
      btn.setAttribute('title', text);
      btn.setAttribute('aria-label', text);
    });
  };

  const apply = (mode, persist) => {
    const dark = mode === 'auto' ? !!(mq && mq.matches) : mode === 'dark';
    root.setAttribute('data-mode', mode);
    root.setAttribute('data-theme', dark ? 'dark' : 'light');
    if (persist) {
      try {
        localStorage.setItem(KEY, mode);
      } catch (e) {
        /* private mode: the choice simply does not outlive the tab */
      }
    }
    syncButtons(mode);
  };

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-ag-theme-btn]');
    if (!btn) return;
    event.preventDefault();
    apply(NEXT[currentMode()], true);
  });

  if (mq) {
    const onSystemChange = () => {
      if (currentMode() === 'auto') apply('auto', false);
    };
    if (mq.addEventListener) mq.addEventListener('change', onSystemChange);
    else if (mq.addListener) mq.addListener(onSystemChange);
  }

  // The header can come back from the theme editor with a stale label.
  document.addEventListener('shopify:section:load', () => syncButtons(currentMode()));

  syncButtons(currentMode());
})();
